// extracted by mini-css-extract-plugin
export var inWhich = "letter-heading-module--inWhich--459a5";
export var letterHeading = "letter-heading-module--letterHeading--e2b4b";